import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CompanyService from "../services/companyService";
import StorageService from "../services/StorageService";

export default function CompanySelection() {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);



  useEffect(() => {
    //  Redirect to login if user session is missing
    if (!StorageService.loginData()) {
      navigate("/");
      return;
    }
    document.getElementById("mainHeader").style.left = "0px";

    const fetchCompanies = async () => {
      try {
        const data = await CompanyService.getActiveCompanies();
        console.log("Fetched Companies:", data);
        setCompanies(data.data);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchCompanies();
  }, []);

  const handleSelection = (company) => {
    console.log("Selected Company:", company);
    StorageService.setActiveCompany(company);
    navigate("/cpnl/dashboard");
  };

  const handleLogout = () => {
    localStorage.clear();

    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      navigate("/");
    };

    navigate("/");
  };

  return (
    <>
      <header id="mainHeader" className="pc-header">
        <div className="header-wrapper">

          <div className="ms-auto">
            <div className="list-unstyled nav">
              <div className="pc-h-item dropdown">
                <button
                  type="button"
                  id="user-profile-dropdown"
                  aria-expanded="false"
                  aria-haspopup="true"
                  className="pc-head-link arrow-none me-0 dropdown-toggle btn btn-link"

                  title="Logout"
                  onClick={handleLogout}
                >
                  <i className="ph ph-sign-out" />
                </button>

              </div>


            </div>
          </div>
        </div>
      </header>

      <div className="" style={{ paddingTop: '15%' }}>
        <div className="container col-6 mt-6">
          <div className="page-header">
            <div className="page-block">
              <div className="align-items-center row">
                <div className="page-header-title text-capitalize text-center col-md-12">
                  <h3>Select Company</h3>
                </div>
              </div>
            </div>
          </div>
          {companies.length > 0 ? (
            companies.map((company, index) => (
              <div className="col-xl-6 col-md-12 float-start" key={index}>
                <div
                  className="card m-1"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSelection(company)}
                >
                  <div className="card-body">
                    <div className="gap-4 vstack">
                      <div className="justify-content-between align-items-center hstack">
                        <div className="mb-0 hstack">
                          <i className="ph ph-arrow-up text-success f-30 m-r-10" />
                          <h3 className="f-w-300 mb-0">
                            {company.companyName}
                          </h3>
                        </div>
                      </div>
                      <div className="m-t-5 progress">
                        <div
                          role="progressbar"
                          className={index == 0 ? "bg-brand-color-1 progress-bar" : "bg-brand-color-2"}
                          aria-valuenow={100}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center mt-4">Loading companies...</p>
          )}
          {/* <div className="col-xl-6 col-md-12 float-end">
            <div className="card m-1" style={{ cursor: "pointer", }} onClick={() => handleSelection("Devi Projects")}>
              <div className="card-body">
                <div className="gap-4 vstack">
                  
                  <div className="justify-content-between align-items-center hstack">
                    <div className="mb-0 hstack">
                      <i className="ph ph-arrow-up text-success f-30 m-r-10" />
                      <h3 className="f-w-300 mb-0">Devi Projects</h3>
                    </div>
                  </div>
                  <div className="m-t-5 progress">
                    <div
                      role="progressbar"
                      className="bg-brand-color-2 progress-bar"
                      aria-valuenow={100}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {/* <div
          className="mb-0 card"
          style={{
            width: "800px",
          }}
        >
          <div
            className="card-body"
            style={{
              width: "800px",
            }}
          >
            <div className="text-center mb-4">
              <h4
                className="f-w-500"
                style={{
                  fontSize: "2.5rem",
                }}
              >
                Select Your Company
              </h4>
            </div>

            <div className="d-flex justify-content-center gap-4">
              <div
                className="card shadow p-5 text-center"
                style={{
                  cursor: "pointer",
                  height: "150px",
                  width: "500px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  // fontSize: "2.5rem",
                }}
                onClick={() => handleSelection("Devi Associates")}
              >
                <h5 style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
                  {" "}
                  Devi Associates
                </h5>
              </div>

              <div
                className="card shadow p-5  text-center"
                style={{
                  cursor: "pointer",
                  height: "150px",
                  width: "500px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => handleSelection("Devi Projects")}
              >
                <h5 style={{ fontSize: "1.3rem", fontWeight: "bold" }}>
                  Devi Projects
                </h5>
              </div>
            </div>
          </div>
        </div> */}
      </div>

      {/* <div className="auth-main">
        <div className="auth-wrapper v1">
          <div className="auth-form">
            <div className="position-relative">
              <div className="auth-bg">
                <span className="r" />
                <span className="r s" />
                <span className="r s" />
                <span className="r" />
              </div>

            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
